module.exports = __webpack_public_path__ + "img/HH2020plakat.5028e109.jpg";